<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <section>

        <!-- 查询次数与时间 -->
        <div class="MainBox" v-if="datas.verify">
          <div class="MainTitle">首次查询</div>
          <div class="MainDatasBox">
            <div class="ProductMain">
              <ul class="ProductCustom">
                <li>扫码次数：{{ datas.scan_count }}</li>
                <li>首次扫码时间：{{ datas.scan_first_time }}</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 产品信息 -->
        <div class="MainBox">
          <div class="MainTitle">产品信息</div>
          <div class="MainDatasBox">
            <div class="ProductMain">
              <ul class="ProductDatasBox" v-if="datas.prod_is_show == 1">
                <li class="ProductImg backImg" :style="{ backgroundImage: 'url(' + datas.product.img + ')' }"></li>
                <li class="ProductDatas">
                  <p v-if="datas.prod_name_is_show == 1">产品名称：{{ datas.product.name }}</p>
                  <p v-if="datas.product.attribute" v-for="val in datas.product.attribute"
                    v-text="val.key + '：' + val.value"></p>
                  <p v-if="datas.batch && datas.batch_is_show == 1" v-text="'上市批次：' + datas.batch.name"></p>
                  <p v-if="datas.attribute && datas.attribute.ship_date" v-text="'上市时间：' + datas.attribute.ship_date"></p>
                  <p v-if="datas.product.period && datas.prod_name_is_show == 1"><i
                      class="letter">保质期</i>：{{ datas.product.period }}</p>
                  <p v-if="datas.product.unit && datas.prod_name_is_show == 1">商品规格：{{ datas.product.unit }}</p>
                  <p v-if="datas.product.introduce && datas.prod_name_is_show == 1">商品描述：{{ datas.product.introduce }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 防伪验证 -->
        <div class="MainBox" v-if="datas.verify">
          <div class="MainTitle">防伪验证</div>
          <div class="MainDatasBox">
            <p class="inputBox">
              <a class="inputBoxMain"><input @keyup.enter="CodeVerify" type="text" v-model="vcode" placeholder="请在这里输入防伪码" /></a>
              <i class="queryIcon" @click="CodeVerify"><img src="../../static/images/query-01.png"></i>
            </p>
          </div>
        </div>

        <!-- 质检信息 -->
        <div class="MainBox" v-if="datas.batch && datas.batch_is_show == 1 && datas.batch.qc">
          <div class="MainTitle">质检信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.batch.qc" v-bind:key="index">
              <p v-if="item.ix == 0">{{ item.key }}：{{ item.value }}</p>
              <p v-else><i class="qckey">{{ item.key }}：</i><img class="qcImg" :src="item.value"></p>
            </div>
          </div>
        </div>

        <!-- 企业信息 -->
        <div class="MainBox" v-if="datas.business && datas.business_is_show == 1">
          <div class="MainTitle">企业信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow">企业名称：{{ datas.business.name }}</div>
            <div class="MainDatasRow" v-if="datas.business.linkman"><i class="letter">联系人</i>：{{ datas.business.linkman }}
            </div>
            <div class="MainDatasRow" v-if="datas.business.linkphone">联系电话：{{ datas.business.linkphone }}</div>
            <div class="MainDatasRow" v-if="datas.business.baddress">企业地址：{{ datas.business.baddress }}</div>
            <div class="MainDatasRow intro" v-if="datas.business.intro">企业简介：<a v-html="datas.business.intro"></a></div>
            <div class="MainDatasRow" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data"
              v-text="val.key + '：' + val.value"></div>
          </div>
        </div>

        <header>
          <div class="MainBox" style="border-radius: 0.25rem;">
            <div class="swiper-container banner">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                  v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </header>

        <!-- 生产流程 -->
        <div class="MainBox" v-if="datas.process && datas.process_is_show == 1">
          <div class="MainTitle">生产流程</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.process" v-bind:key="index">
              <p>{{ index + 1 }}.{{ item.name }}：{{ item.date.substring(0, 10) }}</p>
            </div>
          </div>
        </div>

        <!-- 生产流程演示 -->
        <div class="MainBox"
          v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
          <div class="MainTitle">生产流程</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.process_demo" v-bind:key="index">
              <p>{{ index + 1 }}.{{ item.name }}：{{ item.date }}</p>
            </div>
          </div>
        </div>

        <!-- 经销商流程-北京华千新技术有限公司-定制 -->
        <div class="MainBox" v-if="datas.business.rootid == 100010094 && datas.dealer && datas.dealer_is_show == 1">
          <div class="MainTitle">发往城市</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.dealer" v-bind:key="index">
              <p>{{ item.linkaddress }}</p>
            </div>
          </div>
        </div>

        <!-- 经销商流程-标准 -->
        <div class="MainBox" v-if="datas.business.rootid != 100010094 && datas.dealer && datas.dealer_is_show == 1">
          <div class="MainTitle">经销商流程</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.dealer" v-bind:key="index">
              <p>{{ index + 1 }}.{{ item.name }}：{{ item.date.substring(0, 10) }}</p>
            </div>
          </div>
        </div>

        <!-- 视频信息 -->
        <div class="MainBox" v-if="datas.video && datas.video_is_show == 1">
          <div class="MainTitle">视频信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow">
              <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
                :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
                <source :src="datas.video.url" type="video/mp4">
              </video>
            </div>
          </div>
        </div>

        <!-- 自定义栏目 -->
        <div class="MainBox" v-if="datas.ref && datas.ref_is_show == 1" v-for="(item, index) in datas.ref"
          v-bind:key="index">
          <div class="MainTitle" v-text="item.name"></div>
          <div class="MainDatasBox">
            <ul class="MainRefDatasBox">
              <li v-for="(val, ix) in item.datas" v-bind:key="ix">
                <a v-if="val.type == 0" v-text="val.data"></a>
                <img v-else :src="val.data">
              </li>
            </ul>
          </div>
        </div>

        <!-- 自定义底部菜单 -->
        <div class="MainBox" v-if="datas.menu && datas.menu_is_show == 1">
          <ul class="MainMenuRow CliclStyle" v-for="(item, index) in datas.menu" v-bind:key="index"
            @click="ClickMenu(item)">
            <li class="MainMenuIcon">
              <i v-if="item.icon" class="backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></i>
              <i v-else class="backImg"
                :style="{ backgroundImage: 'url(../../static/images/icon' + item.type + '.png)' }"></i>
              <span class="icon iconfont iconyou MainMenuArrows"></span>
            </li>
            <li class="MainMenuDatas">
              <p class="MainMenuDatasTit onlyOneRow" v-text="item.name"></p>
              <p class="MainMenuDatasTxt onlyOneRow" v-text="item.describe"></p>
            </li>
          </ul>
        </div>

        <!-- 北京华千新技术有限公司-定制 -->
        <section v-if="datas.business.rootid == 100010094">
          <div class="huaqianxin-box"></div>
          <div class="MainBox huaqianxin">
            <div class="MainTitle"><a href="http://www.line365.com.cn">官网：http://www.line365.com.cn</a></div>
          </div>
        </section>

        <!-- 提示框 -->
        <section id="MaskedBlock" v-if="hintTxt">
          <i class="Masked"></i>
          <div class="ToolTip">
            <ul>
              <li>{{ datas.business.name }}</li>
              <li class="MaskedMain" v-text="hintTxt"></li>
              <li class="confirm" v-on:click="CloseTip">确定</li>
            </ul>
          </div>
        </section>

      </section>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal17',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      }
    }
  },
  created() {
    self = this;

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

  },
  updated() {
    new Swiper('.banner', {
      autoplay: {
        delay: 5000
      },//可选选项，自动滑动
      loop: true, //可选选项，开启循环
      // pagination: {
      //   el: '.swiper-pagination',
      //   bulletActiveClass : 'Normal07-banner-active',
      // }
    })

    if (self.datas.video) {
      self.initVideo();
    }
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.queryContent = response.data.meta;
            self.isShow = true;
            let msg;
            // if(self.queryContent.query_count > 1 && !self.datas.many_antifake_msg){
            //   msg = "您查询的码标已经被多次扫描，谨防假冒!";
            // }
            if(self.queryContent.query_count > 1 && self.datas.many_antifake_msg){
              msg = self.datas.many_antifake_msg;
            }
            if(self.queryContent.query_count <= 999 && !self.datas.first_antifake_msg){
              msg = `您所查询的是 ${self.datas.business.name} 正品，当前查询次数为 ${json.meta.query_count} 次，感谢查询 ！`;
            }
            if(self.queryContent.query_count <= 999 && self.datas.first_antifake_msg){
              msg = `${self.datas.first_antifake_msg}${self.datas.product.name}为正品，当前查询次数为${self.queryContent.query_count}次，感谢查询！首次查询时间${self.queryContent.query_first_time}`;
            }
            self.hintTxt = msg;

          } else {
            self.isShow = false;
          }

        }).catch(function (error) {
          console.log(error);
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(VideoBox, {
        controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false,  //自动播放属性,muted:静音播放
        preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    }
  }
}
</script>

<style scoped>
.banner {
  border-radius: .25rem;
  overflow: hidden;
  background: #EEE;
}

.banner img {
  display: block;
  width: 100%;
}

.MainBox {
  margin: .3rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  font-size: .58rem;
  background-color: #FFF;
}

.MainTitle {
  color: #FFF;
  padding: .4rem .5rem;
  background: #659a64 linear-gradient(#6aa869, #659a64) repeat scroll 0 0;
}

.MainDatasBox {
  margin: .3rem;
  overflow: hidden;
  border-radius: .25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.MainDatasRow {
  word-break: break-all;
  padding: .4rem .5rem;
  border-bottom: 1px solid #F3F3F3;
}

.MainDatasRow p {
  position: relative;
}

.intro{
  line-height: 22px;
}

.ProductMain {
  padding: .4rem .5rem;
}

.ProductDatasBox {
  overflow: hidden;
  margin-bottom: .4rem;
}

.ProductImg {
  float: left;
  width: 6rem;
  height: 6rem;
  background-color: #F3F3F3;
}

.ProductDatas {
  float: left;
  margin-left: .5rem;
  width: calc(100% - 6.5rem);
}

.ProductDatas p:first-child {
  margin-top: 0;
}

.ProductDatas p {
  margin-top: .4rem;
}

.ProductCustom li:first-child {
  margin-top: 0;
}

.ProductCustom li {
  margin-top: .4rem;
}

.letter {
  letter-spacing: .19rem;
}

.qckey {
  position: absolute;
  top: 0;
  left: 0;
  width: 2.9rem;
}

.qcImg {
  display: block;
  padding-left: 3rem;
  width: calc(100% - 5rem);
}

.VideoBox {
  width: 100%;
}

.MainRefDatasBox {
  padding: .5rem;
}

.MainRefDatasBox li:first-child {
  margin-top: 0;
}

.MainRefDatasBox li {
  line-height: .9rem;
  font-size: .58rem;
  margin-top: .3rem;
}

.MainRefDatasBox li img {
  display: block;
  width: 100%;
}

.MainMenuRow {
  padding: .5rem;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid #F3F3F3;
}

.MainMenuRow:last-child {
  border-bottom: 0;
}

.MainMenuIcon {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  background-color: #5f9cc5;
  margin-right: .5rem;
  border-radius: .2rem;
}

.MainMenuIcon i {
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  margin: .4rem;
}

.MainMenuDatas {
  float: left;
  width: calc(100% - 3.5rem);
}

.MainMenuDatasTit {
  margin-top: .1rem;
  font-size: .58rem;
}

.MainMenuDatasTxt {
  font-size: .55rem;
  color: #666;
  margin-top: .15rem;
}

.MainMenuArrows {
  position: absolute;
  right: .5rem;
  top: calc(50% - .4rem);
  color: #666;
  font-size: .55rem;
}

.CliclStyle:active {
  background: #F6F6F6;
}

.CliclStyle:focus {
  background: #FFF;
}

.huaqianxin-box {
  height: 50px;
}

.huaqianxin {
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0;
}

.huaqianxin .MainTitle {
  padding: 0;
}
.huaqianxin a{
  padding: 15px 0;
  color: #FFF;
  display: block;
  text-decoration: none;
}
.confirm {
  background-color: #659a64 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal17.vue